// Settings pages a VIEWER may open. Everything else redirects to the profile.
export const VIEWER_SETTINGS_HREFS = [
	"/settings/profile",
	"/settings/notifications",
	"/settings/notifications/inbox",
	"/settings/notifications/email",
	"/settings/notifications/slack",
	"/settings/mcp",
	"/settings/general",
	"/settings/members",
	"/settings/plans",
	"/settings/plans/pricing",
	"/settings/plans/invoices",
]

export function isViewerSettingsHref(pathname: string): boolean {
	return VIEWER_SETTINGS_HREFS.includes(pathname)
}
